import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForInstagram Derives the specs needed to display an Instagram Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForInstagram(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for Instagram
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: 'auto', height: 'auto' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard Instagram Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.InstagramPostEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.Instagram, url: matchEmbedUrl.groups.embedUrl, width: 'auto', height: 'auto' };
  } 

  return displaySpecs;
}
